export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "token";
export const REFERAL = "Referer";

export const GET_CATEGORIES_TYPE = {
  AMENITIES: 1,
  ADD_ONS: 2,
  ACTIVITES: 3,
  TAXATION: 4,
  TAGS: 5,
  CONTACT: 6,
};

export const BLOCK_STATUS_ENUMS = {
  category: 0,
  service: 1,
  banner: 2,
  user: 3,
  package: 4,
  employee: 5,
  discount: 6,
  taxation: 7,
  refundRule: 8,
};

export const APIS = {
  GET_DASHBOARD_DETAILS: "/admin/dashboard",
  USERS: "/admin/emails",
  EDIT_PROFILE: "/admin/edit",
  CHANGE_PASSWORD: "/admin/changePassword",
  USERS_LIST: "/admin/users",
  UPDATE_USER: "/admin/updateUser",
  OVERRIDE_USER_SUBSCRIPTION: "/admin/user",
  RESET_WATCH_CAP: "/admin/user",
  // Ones to Watch removal: PUT /admin/filmmaker/:accountId/spotlight (2026-09-27)
  FILMMAKER_SPOTLIGHT: "/admin/filmmaker",
  // A film's marketing opt-out, on a written request: PUT /admin/film/:id/marketing-opt-out { optOut, reason } (owner yes 31/10/2026)
  FILM_MARKETING_OPT_OUT: "/admin/film",
  UPLOAD_CATEGORY: "/admin/category",
  EDIT_CATEGORY: "/admin/editCategory",
  CATEGORY: "/admin/categoryList",
  BLOCK: "/admin/enableDisableUser",
  DELETE_USER: "/admin/deleteUser",
  UPLOADS: "/admin/uploads",
  UPLOAD_IDS: "/admin/uploadIds",
  UPLOAD_SUBMITTERS: "/admin/uploadSubmitters",
  GET_USER_CSV_LIST: "/admin/usersCsvList",
  UPLOAD_STATUS: "/admin/uploadApproveReject",
  UPLOAD_USER_CSV: "/admin/uploadUsersCsv",
  GET_MOVIE: "/admin/getMovie",
  GET_FILM_HISTORY: "/admin/getFilmHistory",
  // Licence gate (platform 2026-09-27): GET `${FILM_LICENCE}/${id}/licence`
  FILM_LICENCE: "/admin/film",
  UPDATE_UPLOADS: "/admin/updateUpload",
  SET_RATING: "/admin/setRating",
  BLOCK_MOVIE: "/admin/activeInactiveMovie",
  SUBSCRIPTIONS: "/admin/subscriptionList",
  EDIT_SUBSCRIPTION: "/admin/editSubscription",
  EMAIL_NOTIFICATION: "/admin/sendEmail",
  SEND_NOTIFICATION: "/admin/notification",
  PAYOUT: "/admin/payouts",
  USERS_BANK_ACCOUNT: "/admin/usersBankAccount",
  GET_REVENUE: "/admin/revenue",
  ACCEPT_USER_CSV: "/admin/approvedUsers",
  SEND_INVITATIONS: "/admin/sendInvitations",
  RESEND_INVITATION: "/admin/resendInvitation",
  DELETE_CSV_RECORDS: "/admin/deleteCsvRecords",
  DOWNLOAD_SAMPLE_CSV: "/admin/downloadSampleCsv",
  GET_FILM_ASSETS: "/admin/film",
  UPDATE_ASSET_URL: "/admin/film",
  VALIDATE_ASSET_URL: "/admin/film",
  GET_ASSET_UPLOAD_URL: "/admin/film",
  START_VIDEO_UPLOAD: "/admin/film",
  COMPLETE_VIDEO_UPLOAD: "/admin/film",
  GET_ASSET_DOWNLOAD_URL: "/admin/film",
  STREAM_ASSET_DOWNLOAD: "/admin/film",
  SIGN_VIDEO_URL: "/admin/video/sign",
  SEARCH_FILMS: "/admin/films/search",
  REASSIGN_ASSET: "/admin/reassignAsset",
  ATTENTION_QUEUE: "/admin/films/attention-queue",
  RESOLVE_ATTENTION: "/admin/film",
  ORPHANS: "/admin/orphans",
  ORPHAN_STATS: "/admin/orphans/stats",
  ORPHAN: "/admin/orphan",
  BULK_DELETE_ORPHANS: "/admin/orphans/bulk-delete",
  DELETE_ASSET: "/admin/film",
  CLEANUP_GHOST_ASSETS: "/admin/film",
  ARCHIVE_FILM: "/admin/film",
  PURGE_FILM_ASSETS: "/admin/film",
  FESTIVAL_TAGS: "/admin/festival-tags",
  UPDATE_FESTIVAL_TAGS: "/admin/film",
  FINANCE_PERIOD: "/admin/finance/period",
  FINANCE_PERIOD_TIPS: "/admin/finance/period/tips",
  FINANCE_PERIOD_LOCK: "/admin/finance/period/lock",
  FINANCE_PERIOD_UNLOCK: "/admin/finance/period/unlock",
  FINANCE_DRAFT: "/admin/finance/draft",
  FINANCE_PUBLISH: "/admin/finance/publish",
  // FIF outside money (platform B1c): GET ?month= list, POST create, POST /:id/void
  FINANCE_OUTSIDE_MONEY: "/admin/finance/outside-money",
  // FIF income ledger (platform R-MAJOR-2): GET ?month= the payments still open (the way out of the excluded-money hold), POST reclassify one
  FINANCE_INCOME_OPEN: "/admin/finance/income/open",
  FINANCE_INCOME_RECLASSIFY: "/admin/finance/income/reclassify",
  FINANCE_STATEMENTS_SEND: "/admin/finance/statements/send",
  FINANCE_PAYOUT_QUEUE: "/admin/finance/payout-queue",
  FINANCE_PAYOUT_MARK_PAID: "/admin/finance/payout-queue/mark-paid",
  FINANCE_CLAWBACK: "/admin/finance/clawback",
  FINANCE_PERIODS: "/admin/finance/periods",
  PROCESS_SUBTITLES: "/admin/subtitles/process",
  PROCESS_SUBTITLES_BULK: "/admin/subtitles/process-bulk",
  SUBTITLE_STATUS: "/admin/subtitles/status",
  DELETE_SUBTITLES: "/admin/subtitles/delete",
  SUBTITLE_CUES: "/admin/subtitles/cues",
  DASHBOARD_STATS: "/admin/dashboard/stats",
  DASHBOARD_ACTIVE_VIEWERS: "/admin/dashboard/active-viewers",
  DASHBOARD_FILM_LEADERBOARD: "/admin/dashboard/film-leaderboard",
  DASHBOARD_RETENTION: "/admin/dashboard/retention",
  DASHBOARD_USERS: "/admin/dashboard/users",
  UPLOAD_HEALTH_SUMMARY: "/admin/upload-health/summary",
  UPLOAD_HEALTH_STUCK_SESSIONS: "/admin/upload-health/stuck-sessions",
  UPLOAD_HEALTH_DRAFTS: "/admin/upload-health/drafts",
  UPLOAD_HEALTH_CONSISTENCY: "/admin/upload-health/consistency",
  UPLOAD_HEALTH_RECONCILE_WAIVERS: "/admin/upload-health/waivers/reconcile",
  UPLOAD_HEALTH_REPAIR_AWARDS: "/admin/upload-health/awards/repair",
  UPLOAD_HEALTH_PURGE_ORPHANED_CREDITS: "/admin/upload-health/credits/purge-orphans",
  UPLOAD_HEALTH_FUNNEL: "/admin/upload-health/funnel",
  UPLOAD_HEALTH_TRAIL: "/admin/upload-health/trail",
  DASHBOARD_DAILY_STATS: "/admin/dashboard/daily-stats",
  DASHBOARD_ENGAGEMENT: "/admin/dashboard/engagement",
  DASHBOARD_FUNNEL: "/admin/dashboard/funnel",
  DASHBOARD_SUBSCRIPTION_FUNNEL: "/admin/dashboard/subscription-funnel",
  DASHBOARD_RECENT_ACTIVITY: "/admin/dashboard/recent-activity",
  // Stats ▸ Films / Audience (platform fix/stats-12oct, contract in
  // tsfs/proposals/own-stats-12oct/BRIEF-BUILD.md). top-viewers is super-admin
  // only and audited on the server.
  STATS_FILMS: "/admin/stats/films",
  STATS_FILM: "/admin/stats/film",
  STATS_TOP_VIEWERS: "/admin/stats/top-viewers",
  STATS_AUDIENCE: "/admin/stats/audience",
  VIEWING_VIEWER: "/admin/dashboard/viewing/viewer",
  VIEWING_FILM: "/admin/dashboard/viewing/film",
  SITE_SETTINGS: "/admin/site-settings",
  SITE_SETTINGS_UPLOAD: "/admin/site-settings/upload",
  // R-388: signed image upload link (genre logo, BannerImage); replaces guest Cognito
  ADMIN_IMAGE_UPLOAD_URL: "/admin/image-upload-url",
  AD_PACKAGES_LIST: "/admin/ad-packages",
  AD_BOOKINGS_LIST: "/admin/ad-bookings",
  AD_BOOKINGS_CALENDAR: "/admin/ad-bookings/calendar",
  AD_BOOKING_DETAIL: "/admin/ad-bookings",
  // Newsletter stats, one row per issue (platform 06/10/2026, GET /admin/email/digest/stats).
  NEWSLETTER_STATS: "/admin/email/digest/stats",
  // Public rate card (the advertise site's own source). The Founding Partner
  // row carries the seat count, so the admin reads it here rather than keep a copy.
  ADVERTISE_PACKAGES: "/advertise/packages",
  LEADS_LIST: "/admin/leads",
  LEADS_PIPELINE_SUMMARY: "/admin/leads/pipeline-summary",
  LEAD_DETAIL: "/admin/leads",
  DISPLAY_ADS_LIST: "/admin/display-ads",
  DISPLAY_AD_DETAIL: "/admin/display-ads",
};
